import { Box, Divider, Flex, Grid, Text, type TextProps } from '@chakra-ui/react';
import { CONTENT_MEDIA_QUERY } from './messagingHistory.constants';

const HeaderCell = (props: TextProps) => (
  <Text
    color="charcoalGrey"
    fontSize="16px"
    fontWeight="500"
    lineHeight="130%"
    textStyle="bodyFamilyMedium"
    {...props}
  />
);

const MessageHistoryHeader = ({ title, total, dateLabel, }: {
  title: string;
  total: number;
  dateLabel: string;
}) => (
  <Box>
    <Flex align="baseline" gap="12px" mb="24px">
      <Text as="h2" color="primaryDark" textStyle="heading3">
        {title}
      </Text>
      <Text color="grey" fontSize="16px">
        [{total}]
      </Text>
    </Flex>
    <Divider borderColor="subtleBorder" />
    <Grid
      alignItems="center"
      columnGap={{ base: 3, md: 6 }}
      px="16px"
      py="20px"
      templateColumns={{
        base: 'minmax(0, 1fr) auto 32px',
        md: 'minmax(140px, 1fr) 80px 130px minmax(150px, 1fr) 32px',
      }}
      sx={{
        [CONTENT_MEDIA_QUERY]: {
          gridTemplateColumns:
            'minmax(140px, 1fr) minmax(220px, 2fr) 80px 130px minmax(150px, 1fr) 32px',
        },
      }}
    >
      <HeaderCell>Name</HeaderCell>
      <HeaderCell
        display="none"
        sx={{ [CONTENT_MEDIA_QUERY]: { display: 'block' } }}
      >
        Content
      </HeaderCell>
      <HeaderCell textAlign="center">Recipients</HeaderCell>
      <HeaderCell textAlign="center">Status</HeaderCell>
      <HeaderCell textAlign="center">{dateLabel}</HeaderCell>
      <Box aria-hidden="true" />
    </Grid>
    <Divider borderColor="subtleBorder" />
  </Box>
);

export default MessageHistoryHeader;
